"use strict";

var _slicedToArray = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _assertThisInitialized = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _getPrototypeOf = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _get = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _inherits = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternSet = exports.InternMap = void 0;
var InternMap = /*#__PURE__*/function (_Map) {
  _inherits(InternMap, _Map);
  function InternMap(entries) {
    var _this;
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : keyof;
    _classCallCheck(this, InternMap);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternMap).call(this));
    Object.defineProperties(_assertThisInitialized(_this), {
      _intern: {
        value: new Map()
      },
      _key: {
        value: key
      }
    });
    if (entries != null) {
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            _key2 = _step$value[0],
            value = _step$value[1];
          _this.set(_key2, value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return _this;
  }
  _createClass(InternMap, [{
    key: "get",
    value: function get(key) {
      return _superPropGet(InternMap, "get", this, 3)([intern_get(this, key)]);
    }
  }, {
    key: "has",
    value: function has(key) {
      return _superPropGet(InternMap, "has", this, 3)([intern_get(this, key)]);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      return _superPropGet(InternMap, "set", this, 3)([intern_set(this, key), value]);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return _superPropGet(InternMap, "delete", this, 3)([intern_delete(this, key)]);
    }
  }]);
  return InternMap;
}(_wrapNativeSuper(Map));
exports.InternMap = InternMap;
var InternSet = /*#__PURE__*/function (_Set) {
  _inherits(InternSet, _Set);
  function InternSet(values) {
    var _this2;
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : keyof;
    _classCallCheck(this, InternSet);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InternSet).call(this));
    Object.defineProperties(_assertThisInitialized(_this2), {
      _intern: {
        value: new Map()
      },
      _key: {
        value: key
      }
    });
    if (values != null) {
      var _iterator2 = _createForOfIteratorHelper(values),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var value = _step2.value;
          _this2.add(value);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    return _this2;
  }
  _createClass(InternSet, [{
    key: "has",
    value: function has(value) {
      return _superPropGet(InternSet, "has", this, 3)([intern_get(this, value)]);
    }
  }, {
    key: "add",
    value: function add(value) {
      return _superPropGet(InternSet, "add", this, 3)([intern_set(this, value)]);
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      return _superPropGet(InternSet, "delete", this, 3)([intern_delete(this, value)]);
    }
  }]);
  return InternSet;
}(_wrapNativeSuper(Set));
exports.InternSet = InternSet;
function intern_get(_ref, value) {
  var _intern = _ref._intern,
    _key = _ref._key;
  var key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set(_ref2, value) {
  var _intern = _ref2._intern,
    _key = _ref2._key;
  var key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete(_ref3, value) {
  var _intern = _ref3._intern,
    _key = _ref3._key;
  var key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}